import {Component, Injectable, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {SchoolService} from '@services/school/school.service';
import {AccountService} from '@services/account/account.service';
import {SubscriptionService} from '@services/subscription/subscription.service';
import {Store} from '@ngrx/store';
import {Router} from '@angular/router';
import * as AuthReducer from '@store/auth/reducers';
import {MatDialog, MatDialogRef} from '@angular/material';
import {Subject} from 'rxjs';
import {ViewChild} from '@node_modules/@angular/core';
import {GooglePlaceDirective} from '@node_modules/ngx-google-places-autocomplete';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {UpdateAuthUser} from '@store/auth/actions';
import {User} from '@models/user';


@Component({
    selector: 'app-admin-add',
    templateUrl: './admin-add.component.html',
    styleUrls: ['./admin-add.component.scss']
})
export class AdminAddComponent implements OnInit {
  static modalRef: any;

  @ViewChild('placesRef') placesRef: GooglePlaceDirective;

  crateSchoolForm: FormGroup;
  subscribes = [];
  subs = [];
  errors = [];
  user: User;
  tmpAddress: {
    address: string,
    locality: string,
    administrative_area_level_1: string,
    postal_code: string,
    country: string
  } = {
    address: null,
    locality: null,
    administrative_area_level_1: null,
    postal_code: null,
    country: null
  };
  mask$: Subject<string> = new BehaviorSubject(null);
  currentPhoneFormat;
  currentCountryCode;
  addressDisabled: boolean;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private schoolService: SchoolService,
    private accountService: AccountService,
    private subscriptionService: SubscriptionService,
    private authStore: Store<AuthReducer.AuthState>,
    @Optional() public dialogRef: MatDialogRef<AdminAddComponent>
  ) { }

  ngOnInit() {
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        if (val.auth && val.auth.user) {
          this.user = val.auth.user;
        }
      }
    ));

    this.subscriptionService.getAllSub().subscribe(
      (resp: {data: any}) => {
        this.subs = resp.data;
      }
    );

    this.crateSchoolForm = new FormGroup({
      'first_name': new FormControl(null, [Validators.required]),
      'last_name': new FormControl(null, [Validators.required]),
      'email': new FormControl(null, [Validators.required]),
      'confirm_email': new FormControl(null, [Validators.required]),
      'address': new FormControl(null),
      'locality': new FormControl(null),
      'administrative_area_level_1': new FormControl(null),
      'postal_code': new FormControl(null),
      'country': new FormControl(null),
      'subscription_id': new FormControl('', [Validators.required]),
      'phone': new FormControl(null, [Validators.required]),
    });
  }

  create() {

    this.accountService.registerSchoolAdmin({
      first_name: this.crateSchoolForm.get('first_name').value,
      last_name: this.crateSchoolForm.get('last_name').value,
      confirm_email: this.crateSchoolForm.get('confirm_email').value,
      address_line_1: this.crateSchoolForm.get('address').value,
      locality: this.crateSchoolForm.get('locality').value,
      administrative_area_level_1: this.crateSchoolForm.get('administrative_area_level_1').value,
      postal_code: this.crateSchoolForm.get('postal_code').value,
      country: this.crateSchoolForm.get('country').value,
      phone: this.crateSchoolForm.get('phone').value,
      countryCode: this.currentCountryCode,
      email: this.crateSchoolForm.get('email').value,
      subscription_id: this.crateSchoolForm.get('subscription_id').value,
    }).subscribe(
      (resp: {data: {}}) => {
        // this.router.navigate(['/admins']);
        // this.authStore.dispatch(new UpdateAuthUser({schools: resp.data}));
        this.closeWithResult(true);
      }
    );
  }

  handleAddressChange(event) {
    // console.log(event);
    if ( Object.keys(event).every(item => {
      return event[item].length > 0;
    })) {
      let address: any;
      address = event.address_line_1 ? event.address_line_1 : event.administrative_area_level_1 ? event.administrative_area_level_1 : event.country;
      this.tmpAddress.address = event.address_line_1;
      this.tmpAddress.locality = event.locality;
      this.tmpAddress.administrative_area_level_1 = event.administrative_area_level_1;
      this.tmpAddress.postal_code = event.postal_code;
      this.tmpAddress.country = event.country;

      this.crateSchoolForm.get('address').setValue(address);
      this.crateSchoolForm.get('locality').setValue(event.locality);
      this.crateSchoolForm.get('administrative_area_level_1').setValue(event.administrative_area_level_1);
      this.crateSchoolForm.get('postal_code').setValue(event.postal_code);
      this.crateSchoolForm.get('country').setValue(event.country);
    } else {
      this.tmpAddress.address = '';
      this.tmpAddress.locality = '';
      this.tmpAddress.administrative_area_level_1 = '';
      this.tmpAddress.postal_code = '';
      this.tmpAddress.country = '';
    }
  }

  onPhoneError(event) {
    this.crateSchoolForm.get('phone').setErrors({'range': true});
  }

  onCountrychange(event) {
    this.currentCountryCode = event.countryData.dialCode;
    this.currentPhoneFormat = event.placeholder;
    this.mask$.next(event.mask.replace(/[0-9]/g, "0"));
  }

  genCancel(){
    this.close();
  }

  close() {
    this.closeWithResult();
  }

  private closeWithResult(result?: boolean) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
      return;
    }

    if (AdminAddComponent.modalRef) {
      AdminAddComponent.modalRef.close();
      return;
    }

    this.router.navigate(['/admins']);
  }
}
